import React from "react";

import Hero from "./Hero";
import LeftSection from "./LeftSection";
import Universe from "./Universe";
import RightSection from "./RightSection";



function ProductPage() {
    return (
        <>
            <Hero />
            <LeftSection 
            imageURL="media/kite.png" 
            productName="Kite" 
            productDescription="Our ultra-fast flagship trading platform with streaming market data, advanced charts, an elegant UI, and more. Enjoy the Kite experience seamlessly on your Android and iOS devices." 
            tryDemo="https://zerodha-clone-kite.onrender.com" 
            learnMore="https://zerodha-clone-kite.onrender.com" 
            googlePlay="https://zerodha-clone-kite.onrender.com/orders" 
            appStore="https://zerodha-clone-kite.onrender.com/orders" />

            <RightSection imageURL="media/console.png" 
            productName="Console" 
            productDescription="The central dashboard for your Zerodha account. Gain insights into your trades and investments with in-depth reports and visualisations." 
            tryDemo="https://zerodha.com/products/console" 
            learnMore="https://zerodha.com/products/console"  />

            <LeftSection 
            imageURL="media/coin.png" 
            productName="Coin" 
            productDescription="Buy direct mutual funds online, commission-free, delivered directly to your Demat account. Enjoy the investment experience on your Android and iOS devices.." 
            tryDemo="https://coin.zerodha.com/" 
            learnMore="https://zerodha.com/products/kite" 
            googlePlay="https://play.google.com/store/apps/details?id=com.zerodha.coin" 
            appStore="https://apps.apple.com/in/app/coin-by-zerodha-mutual-funds/id1392892554" />

            <RightSection imageURL="media/kiteconnect.png" 
            productName="Kite Connect API" 
            productDescription="Build powerful trading platforms and experiences with our super simple HTTP/JSON APIs. If you are a startup, build your investment app and showcase it to our clientbase." 
            tryDemo="https://zerodha.com/products/api/" 
            learnMore="https://zerodha.com/products/api/"  />

            <LeftSection 
            imageURL="media/varsity.png" 
            productName="Varsity mobile" 
            productDescription="An easy to grasp, collection of stock market lessons with in-depth coverage and illustrations. Content is broken down into bite-size cards to help you learn on the go" 
            tryDemo="https://zerodha-clone-kite.onrender.com/orders" 
            learnMore="https://zerodha-clone-kite.onrender.com/orders" 
            googlePlay="https://play.google.com/store/apps/details?id=com.zerodha.varsity" 
            appStore="https://apps.apple.com/in/app/varsity-by-zerodha/id1474610753" />

            <Universe />
        </>
    );
}

export default ProductPage;